<form class="sdp-saml-wizard-form" [formGroup]="form" novalidate>
	<div class="sdp-clear"></div>
	<div>
		<div class="sdp-form-control">
			<div class="sdp-wizard-field-message">
				{{ "application.wizard.selectType.name.message" | translate }}
			</div>
			<mat-form-field class="sdp-form-control-input-container">
				<input matInput placeholder="{{ 'application.form.label.name' | translate }}" type="text" formControlName="name">
				<mat-error *ngIf="form.controls['name'].hasError('required')">{{ "error.form.name" | translate }}.</mat-error>
				<mat-error *ngIf="form.controls['name'].hasError('pattern')">{{ "error.form.name.pattern" | translate }}.</mat-error>
				<mat-error *ngIf="form.controls['name'].hasError('duplicate')">{{ "error.form.name.duplicate" | translate }}.</mat-error>
			</mat-form-field>
		</div>
		<div class="sdp-form-control">
			<div class="sdp-form-control-input-container">
				<div class="sdp-wizard-field-message">
					{{ "application.wizard.selectType.type.message" | translate }}
				</div>
				<mat-form-field>
					<mat-select formControlName="selectType" class="sdp-application-select-type-select">
						<mat-option [value]="'website'">{{ "application.form.label.web" | translate }} </mat-option>
						<mat-option [value]="'network'">{{ "application.form.label.network" | translate }}</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>
	</div>
</form>